import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/models/role.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-role-create',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <app-form-role (roleData)="createRole($event)" [role]="role"></app-form-role> 
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class RoleCreateComponent implements OnInit {
  role: Role | null = null;

  currentView = 'roles';

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.set('@roleCreate', 'Crear rol');
  }

  createRole(event: any) {
    this.store.createRole(event).subscribe({
      next: (response: any) => {
        this.toastr.success('Rol creado correctamente');
        this.router.navigate(['/roles']);
      },
      error: (error: any) => {
        this.toastr.error('No se pudo crear el rol');
      }
    });
  }

}
